<div class="flex flex-col gap-10">

    <div class="flex flex-col md:flex-row gap-10">
        <div class="flex-1">
            <div class="font-semibold text-xl mb-2">Changer la photo de profil</div>
            <p class="text-gray-500">Mettez à jour votre image de profil ici</p>

            <div class="flex flex-col items-center mt-4 gap-4">
                <img [src]="imageUrl" alt="Profil" width="110" class="rounded-full object-cover" />

                <input type="file" (change)="onFileSelected($event)" accept="image/*"
                    class="text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />

                <span class="text-gray-400 text-xs">Formats JPG, GIF, PNG. Taille max 1Mo</span>
            </div>
        </div>


    </div>

    <div>
        <div class="font-semibold text-xl mb-2">Détails personnels</div>
        <p class="text-gray-500 mb-6">Mettez à jour vos informations de profil ici</p>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div class="flex flex-col">
                <label>Prénom</label>
                <input pInputText type="text" class="max-w-64 text-[16px]" [(ngModel)]="userLastName"  />
            </div>
            <div class="flex flex-col">
                <label>Nom</label>
                <input pInputText type="text" class="max-w-64 text-[16px]" [(ngModel)]="userFirstName" />
            </div>

            <div class="flex flex-col">
                <label>Email</label>
                <input pInputText type="email" class="max-w-64 text-[16px]" [(ngModel)]="userEmail" readonly   />
            </div>

        </div>



        <!-- Boutons Enregistrer / Annuler -->
        <div class="flex  gap-4 mt-8">
            <p-button label="Annuler" icon="pi pi-times" class="p-button-outlined" severity="warn"  (onClick)="cancelEdit()"></p-button>
            <p-button label="Enregistrer" icon="pi pi-check" class="p-button-outlined" severity="success" (onClick)="saveChanges()"></p-button>
        </div>
    </div>

</div>